module.exports = __webpack_public_path__ + "media/assets/images/flags/ky-02bee09381d55f38369da2ba9b2ef1ac.svg";